"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @emails oncall+internationalization
 * 
 * @format
 */

/**
 * An empty no-op for now.
 */
var FbtEnv = {
  setupOnce: function setupOnce() {}
};
module.exports = FbtEnv;